import { Box } from '@mui/material';
import DataCard from 'components/data-card/data-card.component';
import { useSMSTotalsSearch } from 'pages/analytics/sms-reports/sms-reports-landing/sms-reports-search/sms-reports-search.hooks';
import { useTranslation } from 'react-i18next';

const GuestCheckoutVerificationSummaryHeader = () => {
  const { t } = useTranslation();
  const { data, isFetching } = useSMSTotalsSearch(
    'GUEST_CHECKOUT_VERIFICATION',
  );

  return (
    <Box
      display="grid"
      gridTemplateColumns={{ xs: 'repeat(1, 1fr)', lg: 'repeat(2, 1fr)' }}
      gap={2}
    >
      <DataCard
        title={t(
          'page.reportAndAnalytics.smsReports.sections.guestCheckoutVerification.summaryHeader.guestCheckoutVerificationSMSTotal.title',
        )}
        value={data?.smsTotal ?? 0}
        valueType="number"
        description={t(
          'page.reportAndAnalytics.smsReports.sections.guestCheckoutVerification.summaryHeader.guestCheckoutVerificationSMSTotal.description',
        )}
        loading={isFetching}
        data-testid="GuestCheckoutVerificationSMSTotal.Card"
      />
      <DataCard
        title={t(
          'page.reportAndAnalytics.smsReports.sections.guestCheckoutVerification.summaryHeader.guestCheckoutVerificationSMSSegmentTotal.title',
        )}
        value={data?.segmentsTotal ?? 0}
        valueType="number"
        description={t(
          'page.reportAndAnalytics.smsReports.sections.guestCheckoutVerification.summaryHeader.guestCheckoutVerificationSMSSegmentTotal.description',
        )}
        loading={isFetching}
        data-testid="GuestCheckoutVerificationSMSSegmentTotal.Card"
      />
    </Box>
  );
};
export default GuestCheckoutVerificationSummaryHeader;
